import utils from '../../../../utils/utils';

export default {
  setFor: utils.emailHasError,
  'input.drIssuance': utils.numberHasError,
  'input.drCancellation': utils.numberHasError,
  'input.drLowLimit': utils.numberHasError,
  'input.drHighLimit': utils.numberHasError,
};
